export default {

    items: {
        data: []
    }
}